import type { AppAssetsConfig } from '@zto/zpage'
import dayjs from 'dayjs'

export const assets: AppAssetsConfig = {
  images: {
    logo: '/images/logo.png',
    welcome: '/images/welcome.png',
    changePositionImg01: '/images/change-user-position/01.png',
    changePositionImg02: '/images/change-user-position/02.png'
  },

  import_templates: {
    operate_store_advanceFund: {
      name: '运营-门店管理-网点垫资装修门店导入模版',
      url: '/templates/运营-门店管理-网点垫资装修门店导入模版.xlsx',
      fileType: 'xlsx',
      columns: ['depotCode', 'remark']
    },
    operate_objective_cityIndex: {
      name: '运营-目标管理-城市指标导入模版',
      url: '/templates/运营-目标管理-城市指标导入模版.xlsx',
      fileType: 'xlsx',
      columns: [
        { prop: 'organizeId' },
        { prop: 'organizeName' },
        { prop: 'statisticsType' },
        { prop: 'indexType' },
        { prop: 'startValue', type: 'number' },

        { prop: 'planYear', type: 'number' },
        { prop: 'oneIndex', type: 'number' },
        { prop: 'twoIndex', type: 'number' },
        { prop: 'threeIndex', type: 'number' },
        { prop: 'fourIndex', type: 'number' },
        { prop: 'fiveIndex', type: 'number' },
        { prop: 'sixIndex', type: 'number' },
        { prop: 'sevenIndex', type: 'number' },
        { prop: 'eightIndex', type: 'number' },
        { prop: 'nineIndex', type: 'number' },
        { prop: 'tenIndex', type: 'number' },
        { prop: 'elevenIndex', type: 'number' },
        { prop: 'twelveIndex', type: 'number' }
      ]
    },
    operate_store_filingInfo: {
      name: '运营-基础管理-下级门店-备案信息导入模版',
      url: '/templates/运营-基础管理-下级门店-备案信息导入模版.xlsx',
      fileType: 'xlsx',
      columns: [
        { prop: 'depotCode' },
        { prop: 'recordName' },
        { prop: 'recordIdCardCode' },
        { prop: 'recordSubjectCompany' },
        { prop: 'siteName' },
        { prop: 'siteAddress' },
        { prop: 'brandName' },
        { prop: 'siteTypeName' },
        { prop: 'siteAdminName' },
        { prop: 'siteSubject' },
        { prop: 'putOnRecordsCode' },
        {
          prop: 'recordEffectiveDate',
          formatter: (val: any) => {
            // 从excel中取出的时间，会少一天，故加一天（比如：2022-10-20 会显示为Wed Oct 19 2022 23:59:17 GMT+0800 (中国标准时间)）
            const curDate = val ? dayjs(val).add(1, 'days').format('YYYY-MM-DD') : 'Invalid Date'
            // 如果时间格式无效，则处理为null
            return curDate === 'Invalid Date' ? null : curDate + ' 00:00:00'
          }
        },
        {
          prop: 'recordExpiryDate',
          formatter: (val: any) => {
            // 从excel中取出的时间，会少一天，故加一天（比如：2022-10-20 会显示为Wed Oct 19 2022 23:59:17 GMT+0800 (中国标准时间)）
            const curDate = val ? dayjs(val).add(1, 'days').format('YYYY-MM-DD') : 'Invalid Date'
            // 如果时间格式无效，则处理为null
            return curDate === 'Invalid Date' ? null : curDate + ' 23:59:59'
          }
        },
        { prop: 'recordProvince' },
        { prop: 'recordCity' },
        { prop: 'recordDistrict' }
      ]
    },
    operate_store_offline: {
      name: '运营-业务明细数据-线下发放补贴明细导入模版',
      url: '/templates/运营-业务明细数据-线下发放补贴明细导入模版.xlsx',
      fileType: 'xlsx',
      columns: [
        { prop: 'financeBillCode' },
        { prop: 'depotCode' },
        { prop: 'allowanceTypeName' },
        { prop: 'periodName' },
        { prop: 'allowanceAmount' },
        { prop: 'remark' }
      ]
    },
    // 量本利导入模板
    qcp_finance: {
      name: '量本利导入模板',
      url: '/templates/量本利导入模板.xlsx',
      fileType: 'xlsx',
      columns: [
        {
          prop: 'qcpDate',
          formatter: (val: any) => {
            // 从excel中取出的时间，会少一天，故加一天（比如：2022-10-20 会显示为Wed Oct 19 2022 23:59:17 GMT+0800 (中国标准时间)）
            const curDate = val ? dayjs(val).add(1, 'days').format('YYYY-MM-DD') : 'Invalid Date'
            // 如果时间格式无效，则处理为null
            return curDate === 'Invalid Date' ? null : curDate
          }
        },
        { prop: 'objectCodeName' },
        { prop: 'province' },
        { prop: 'city' },
        { prop: 'district' },
        // { prop: 'sectionName' },
        { prop: 'financeSubjectCodeName' },
        { prop: 'inExTypeName' },
        { prop: 'qcpAmount' }
      ]
    },
    // 量本利导入模板-新
    qcp_finance_new: {
      name: '量本利导入模板',
      url: '/templates/量本利导入模板（新）.xlsx',
      fileType: 'xlsx',
      columns: [
        {
          prop: 'qcpDate',
          formatter: (val: any) => {
            // 从excel中取出的时间，会少一天，故加一天（比如：2022-10-20 会显示为Wed Oct 19 2022 23:59:17 GMT+0800 (中国标准时间)）
            const curDate = val ? dayjs(val).add(1, 'days').format('YYYY-MM-DD') : 'Invalid Date'
            // 如果时间格式无效，则处理为null
            return curDate === 'Invalid Date' ? null : curDate
          }
        }, // 业务日期
        { prop: 'objectCodeName' }, // 账套主体
        { prop: 'parentFinanceSubjectCodeName' }, // 上级科目
        { prop: 'financeSubjectCodeName' }, // 科目
        // { prop: 'inExTypeName' }, // 方向
        { prop: 'qcpAmount' }, // 金额（元）/业务量
        {
          prop: 'profitName',
          formatter: (val: any) => {
            return val || ''
          }
        }, // 利润中心
        {
          prop: 'costCode',
          formatter: (val: any) => {
            return val || ''
          }
        } // 成本中心
      ]
    },
    operate_task_ygjworkorder: {
      name: '运营-业务明细-邮管局申诉工单',
      url: '/templates/运营-业务明细-邮管局申诉工单导入模版.xlsx',
      fileType: 'xlsx',
      columns: [
        { prop: 'businessTime' },
        { prop: 'organizeName' },
        { prop: 'organizeId' },
        { prop: 'hour24ResponseRate' },
        { prop: 'hour24ResponseNumber' },
        { prop: 'hour24DisposeRate' },
        { prop: 'hour24DisposeNumber' },
        { prop: 'hour48ResponseRate' },
        {
          prop: 'hour48ResponseNumber'
        },

        { prop: 'hour72ResponseRate' },
        { prop: 'hour72ResponseNumber' },
        { prop: 'hour168ResponseRate' },
        {
          prop: 'hour168ResponseNumber'
        },

        { prop: 'day30ResponseRate' },
        { prop: 'day30ResponseNumber' },
        { prop: 'overRate' },
        {
          prop: 'overNumber'
        },
        { prop: 'standardSatisfactionRate' },
        { prop: 'standardSatisfactionNumber' },
        { prop: 'oneMediateSuccessRate' },
        {
          prop: 'oneMediateSuccessNumber'
        },

        { prop: 'twoMediateSuccessRate' },
        { prop: 'twoMediateSuccessNumber' },
        { prop: 'satisfactionRate' },
        {
          prop: 'satisfactionNumber'
        },
        {
          prop: 'basicSatisfactionNumber'
        },
        { prop: 'noSatisfactionNumber' },
        { prop: 'monthAppealNumber' },
        { prop: 'operationDate' },
        {
          prop: 'operationUserName'
        }
      ]
    }
  }
}
